import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {add_to_cart, dec_to_cart, inc_to_cart, remove_to_cart} from "../../redux/actions/carrito";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronRight, faMinus, faPlus, faStore, faCheckCircle} from "@fortawesome/free-solid-svg-icons";
import Variant from "./variant";
import classNames from "classnames";

function Information({data, carrito, add_to_cart, inc_to_cart, dec_to_cart, remove_to_cart, buy}) {
    const [cantidad, guardarCantidad] = useState(0);
    const [variant, setVariant] = useState(null);
    const [stock, setStock] = useState(0);
    const [enable, setEnable] = useState(false);


    useEffect(() => {
        if (data) {
            updateSimpleOrVariant();
            let producto_carrito = carrito.slice().reverse().find((prd) => prd.id === data.id);
            if (producto_carrito) {
                setVariant(producto_carrito.variant_id);
            } else {
                guardarCantidad(0);
            }
        }
    }, [data]);


    useEffect(() => {
        if (variant) {
            setEnable(true);
            updateCantidad();
            let stock_variant = data.variants.find((prd) => Number(prd.id) === Number(variant)).stock;
            setStock(stock_variant);
        }
    }, [variant]);

    const updateCantidad = () => {
        let query =  carrito.find((prd) => prd.variant_id === Number(variant));
        if (query) {
            guardarCantidad(query.quantity);
        }else{
            guardarCantidad(0);
        }
    }

    const updateSimpleOrVariant = () => {
        let  type =  data.type;
        if (type === "simple") {
            setVariant(data.variants[0].id);
        }
    }



    const add_carrito = () => {
        if (buy) {
            if (cantidad < Number(stock)) {
                guardarCantidad(Number(cantidad) + 1);
                if (cantidad === 0) {

                    add_to_cart({...data, variant_id: Number(variant)}, 1);
                } else {
                    inc_to_cart({...data, variant_id: Number(variant)});
                }
            }else{

            }

        }
    }

    const reducir_carrito = () => {
        if (cantidad === 1) {
            guardarCantidad(cantidad - 1);
            remove_to_cart({...data, variant_id: Number(variant)});
        } else if (cantidad >= 1) {
            guardarCantidad(cantidad - 1);
            dec_to_cart({...data, variant_id: Number(variant)});
        }
    }

    return (
        <>
            {
                data &&
                <div className="prod-info-wrapper">
                    {/* Product Name */}
                    <h1 className="prod-info-title">{data.name}</h1>

                    {/* Store Link */}
                    <Link className="no-underline" to={`/${data.store.slug}`}>
                        <div className="prod-info-store-link">
                            <div className="flex items-center gap-2">
                                <div className="prod-info-store-icon">
                                    <FontAwesomeIcon icon={faStore} className="text-white text-xs"/>
                                </div>
                                <div>
                                    <p className="text-ecoprimary1 font-semibold mb-0 text-sm">
                                       {data.store.name}
                                    </p>
                                    <span className="text-xs text-gray-400">Ver tienda</span>
                                </div>
                            </div>
                            <FontAwesomeIcon
                                icon={faChevronRight}
                                className="text-ecoprimary1 text-sm"/>
                        </div>
                    </Link>

                    {/* Price Section */}
                    <div className="prod-info-price-section">
                        {
                            data.has_offer ?
                                <>
                                    <div className="flex items-baseline gap-2 flex-wrap">
                                        <span className="prod-info-price">Bs. {data.offer_price}</span>
                                        <span className="prod-info-price-old">Bs. {data.previous_price}</span>
                                    </div>
                                    <span className="prod-info-discount-badge">
                                        {((1 - (data.offer_price / data.previous_price)) * 100).toFixed()}% OFF
                                    </span>
                                </>
                                :
                                <span className="prod-info-price">Bs. {data.price}</span>
                        }
                    </div>

                    {/* Stock Indicator */}
                    {stock > 0 &&
                        <div className="prod-info-stock">
                            <FontAwesomeIcon icon={faCheckCircle} className="text-brand-green text-xs"/>
                            <span>En stock</span>
                            <span className="text-gray-400">({stock} disponibles)</span>
                        </div>
                    }

                    {/* Divider */}
                    <hr className="prod-info-divider"/>

                    {/* Variants */}
                    {
                        data.type !== "simple" &&
                        <div className="mb-4">
                            <Variant data={data.variants} variant_id={variant} ps_send={setVariant}/>
                        </div>
                    }

                    {/* Quantity & Buy Controls */}
                    <div className="prod-info-actions">
                        <div className="prod-info-qty-control">
                            <button onClick={() => reducir_carrito()} className={classNames("prod-info-qty-btn",
                                {
                                    "prod-info-qty-btn--active" : enable,
                                    "prod-info-qty-btn--disabled" : !enable,
                                })}>
                                <FontAwesomeIcon icon={faMinus} className="text-sm"/>
                            </button>
                            <span className="prod-info-qty-value">{cantidad}</span>
                            <button onClick={() => add_carrito()} className={classNames("prod-info-qty-btn",
                                {
                                    "prod-info-qty-btn--active" : enable && cantidad < stock,
                                    "prod-info-qty-btn--disabled" : !enable || cantidad === stock,
                                })}>
                                <FontAwesomeIcon icon={faPlus} className="text-sm"/>
                            </button>
                        </div>
                        {
                            cantidad > 0 &&
                            <Link className="no-underline flex-1 md:flex-none"
                                  to={'/mi/carrito'}>
                                <button type="button" className="prod-info-buy-btn">
                                    <span>COMPRAR</span>
                                    <span>&#128722;</span>
                                </button>
                            </Link>

                        }
                    </div>

                    {/* Description */}
                    <div className="prod-info-description">
                        <h2 className="prod-info-description-title">Descripción</h2>
                        <div className="prod-info-description-content"
                             dangerouslySetInnerHTML={{__html: data.description}}/>
                    </div>
                </div>
            }

        </>
    );
}

const mapStateToProps = state => ({
    carrito: state.Cart.carrito,
})

export default connect(mapStateToProps, {
    add_to_cart, inc_to_cart, dec_to_cart, remove_to_cart
})(Information)